import { useAppDispatch } from "Store/hooks";

import { updateVariable } from "../thunks";

import type { ProjectLevelVariable } from "@packages/client";

export function useUpdateVariable({
  organizationId,
  projectId,
  variable
}: {
  organizationId: string;
  projectId: string;
  variable: ProjectLevelVariable;
}) {
  const dispatch = useAppDispatch();

  return data =>
    dispatch(
      updateVariable({
        organizationId,
        projectId,
        variable,
        data
      })
    );
}
